import { render, staticRenderFns } from "./IntegrationRequestForm.vue?vue&type=template&id=9840089a&"
import script from "./IntegrationRequestForm.vue?vue&type=script&lang=js&"
export * from "./IntegrationRequestForm.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationRequestForm.vue?vue&type=style&index=0&id=9840089a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports